import { Component } from '@angular/core';

@Component({
    template: `
  <h1>Requested area does not exist!</h1>
  `
})
export class PageNotFoundComponent {
}
